import { axiosInstance } from "libs/axiosInstance";
import type {
  TSendVerificationCodeToPhoneRes,
  TRequestForGottenEmailRes,
  TVerifyVerificationCodeRes,
  TSendVerificationCodeToPhoneToFindPw,
} from "./auth_types";
import { clearHistory } from "utils/nativeApi";
import { localStorageKeyToken } from "utils/(localStorage)";
import store from "store";

// Account : 로그아웃
// export const logout = () => axiosInstance.post('/api/account/logout');
export const logout = async () => {
  try {
    store.remove(localStorageKeyToken);
    clearHistory();
    window.Kakao.API.request({
      url: "/v1/user/unlink",
    });

    window.location.replace(`${window.location.origin}`); //브라우저 리프레시하며 Redux Store 초기화 & 메인 화면으로 보냄
  } catch (e) {
    console.log("localStorage/sessionStorage is not working");
  }
};

// Account : 탈퇴하기
export const dropout = () => {
  console.log("drop out api ");
  return axiosInstance.post("/my/account/dropout").then(() => {});
};

export const POST_sendVerificationCodeToPhone = async (phoneNumber: string) => {
  const res = await axiosInstance.post<TSendVerificationCodeToPhoneRes>("/account/forgot/v2/verify/request", {
    phone_number: phoneNumber,
  });

  return res.data;
};

export const POST_sendVerificationCodeToPhoneToFindPw = async (
  phoneNumber: string,
  email: string,
  captcha_token: string,
  action: string,
) => {
  const res = await axiosInstance.post<TSendVerificationCodeToPhoneToFindPw>(`/account/forgot-v2/phone`, {
    phone_number: phoneNumber,
    email,
    captcha_token,
    action,
  });
  return res.data;
};

export const POST_resetToPw = async (newPassWord: string, forgotId: string) => {
  const res = await axiosInstance.post<TSendVerificationCodeToPhoneToFindPw>(`/account/forgot/change`, {
    forgot_id: forgotId,
    new_password: newPassWord,
  });
  return res.data;
};

export const POST_verifyVerificationCode = async (verificationId: string, verificationCode: string) => {
  const res = await axiosInstance.post<TVerifyVerificationCodeRes>("/account/forgot/v2/verify/confirm", {
    verification_id: verificationId,
    verification_code: verificationCode,
  });

  return res.data;
};

export const POST_verifyVerificationCodeToFindPw = async (forgotId: string, verificationCode: string) => {
  const res = await axiosInstance.post("/account/forgot/verify", {
    forgot_id: forgotId,
    verification_code: verificationCode,
  });

  return res.data;
};

export const GET_requestForgottenEmail = async (verificationId: string) => {
  const res = await axiosInstance.get<TRequestForGottenEmailRes>(
    `/account/forgot/v2/email?verification_id=${verificationId}`,
  );
  return res.data;
};

export const POST_createTempIdToSignup = async (
  email: string,
  password: string,
  captcha_token: string,
  action: string,
) =>
  await axiosInstance({
    method: "post",
    url: "/account/join/b2c",
    data: {
      email,
      password,
      captcha_token,
      action,
    },
  });
export const POST_phoneNumberToSignup = async (temporary_id: string, phone_number: string) =>
  await axiosInstance({
    method: "post",
    url: `/account/join/b2c/${temporary_id}/phone`,
    data: {
      phone_number,
    },
  });

export const POST_verifyPhoneNumberCode = async ({
  temporary_id,
  verification_code,
  region,
}: {
  temporary_id: string;
  verification_code: string;
  region: string;
}) =>
  await axiosInstance({
    method: "post",
    url: `/account/join/b2c/${temporary_id}/verify-phone`,
    data: {
      verification_code,
      region,
    },
  });

export const POST_userInfoToSignup = async (
  temporary_id: string,
  userInfo: {
    nickname: string;
    birth: string;
    privacy_term: boolean;
    sensitivity_term: boolean;
    service_term: boolean;
    marketing_agreement: boolean;
  },
) =>
  await axiosInstance({
    method: "post",
    url: `/account/join/b2c/${temporary_id}/user-basic`,
    data: { ...userInfo },
  });

export const POST_finalizeSignup = async (temporary_id: string) =>
  await axiosInstance({
    method: "post",
    url: `/account/join/b2c/${temporary_id}/finalize`,
  });

export const GET_checkDuplicatePhoneNumber = (phone_number: string) => {
  const encodedPhoneNumber = encodeURIComponent(phone_number);
  return axiosInstance.get(`/account/b2c/duplicates?phone_number=${encodedPhoneNumber}`);
};

export const modifyUser = ({ user_id, form }: { user_id: string; form: any }) =>
  axiosInstance.put("/my/account/user/" + user_id, form);

export const POST_verifyPw = async (currentPw: string) => {
  const res = await axiosInstance.post("/my/account/password-matches", {
    password: currentPw,
  });
  return res.data;
};

export const putPassword = async (currentPassword: string, newPassword: string) =>
  axiosInstance({
    method: "put",
    url: "/my/account/password",
    data: {
      current_password: currentPassword,
      new_password: newPassword,
    },
  });

/** Account: access token 재발급 */
export const refreshAccessToken = async (refreshToken: string) => {
  const res = await axiosInstance.post("/account/auth/refresh", {
    refresh_token: refreshToken,
  });
  return res.data;
};

/** Account: Account 정보 조회 */
export const getAccountInfo = async () => {
  return axiosInstance.get("my/account");
};

// Account : 로그인
export const login = ({ email, password }: { email: string; password: string }) => {
  return axiosInstance.post("/account/auth/b2c", { email, password });
};

// Account : 이메일 중복 확인
export const checkEmail = (email: string) => axiosInstance.get("/account/b2c/duplicates?email=" + email);

// Account : 회원가입
export const register = ({ email, password }: { email: string; password: string }) =>
  axiosInstance.post("/account/join/b2c", { email, password });

// Account : axios header authorization 기본 설정(로그인 후)
export const setAuthorization = (accessToken: string) => {
  axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
};

/** Account: FCM 토큰 등록 */
export const registerFcmToken = async (fcm_token: string) => {
  try {
    axiosInstance.put(`/my/account/fcm-token/register`, {
      fcm_token: fcm_token,
    });
  } catch (e) {
    alert("Fcm token Err");
  }
};

// User : 계정 내 user 반환
export const getUsers = () => axiosInstance.get("/my/account/users");

export const checkNickname = (nickname: string) =>
  axiosInstance.get(`/account/b2c/duplicates?nickname=${encodeURIComponent(nickname)}`);
